$(document).ready(function () {
  console.log('influencer-giveaway.js loaded');
  // var influencerForm = document.querySelector('#influencer-form');
  // if (influencerForm) {
  //   influencerForm.addEventListener('click', formSubmit);
  // }

  document.querySelectorAll('.common_button').forEach(function(button) {
    button.addEventListener('click', function (e) {
      e.preventDefault(); // stop any default submit/page reload
      formSubmit(e);       // call your existing submission function
    });
  });

  const urlParams = new URL(window.location.href).searchParams;
  const code = urlParams.get('code');
  if (code) {
    localStorage.setItem('influencerGiveawayCode', code); // Store the code
    document.querySelectorAll('.influencer-name').forEach(el => el.textContent = code); // Set the input value
    localStorage.setItem('influencerCode', code);
    document.querySelector('#influencer-code').value = code;
  } else {
    document.querySelectorAll('.influencer-name').forEach(el => el.textContent = 'Influencers'); // Set the input value
  }
  console.log(code); // should log "name" if present
  
  const emailFields = document.querySelectorAll('input[name="email"]');
  emailFields.forEach(field => {
    field.addEventListener("input", (e) => {
      emailFields.forEach(f => {
        if (f !== e.target) f.value = e.target.value;
      });
    });
  });
  
});

function formSubmit(evt) {
  //evt.preventDefault();
  console.log('formSubmit');

  const form = evt.target.closest('form');

  const properties = {};
  const formData = new FormData(form);
  for (const pair of formData.entries()) {
    properties[pair[0]] = pair[1];
  }
  console.log('properties', properties);

  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    localStorage.setItem('influencerUserEmail', properties.email);
  } else {
    localStorage.setItem('influencerUserEmail', '');
  }

  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    document.body.classList.add('loading');
    $('.influencer-email__error').hide();
    klaviyoIdentify(properties);
  } else {
    if ($('.influencer-email__input').val() == '') {
      $('.influencer-email__error').show();
      $('.influencer-email__error').html('Enter your email above');
    } else if ($('.influencer-email__input').val() != '' && !isEmail($('.influencer-email__input').val())) {
      $('.influencer-email__error').show();
      $('.influencer-email__error').html('Please enter valid email address');
    }
    return false;
  }
}

async function klaviyoIdentify(properties) {
  let companyID = 'HEyw3X';
  let listID = 'TzmncS';

  const options = {
    method: 'POST',
    headers: { revision: '2025-01-15', 'content-type': 'application/json' },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'InfluencerGiveaway',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: properties.email,
                properties: properties,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listID,
            },
          },
        },
      },
    }),
  };

  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyID}`, options);
  } catch (error) {
    console.error(error);
  } finally {
    identifyCallback(properties.email);
  }
}

function identifyCallback(email) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: 'influencer_giveaway_lead',
    email: email,
  });

  if (window.TriplePixel) {
    TriplePixel('Contact', { email: email });
  }

  let code = localStorage.getItem('influencerCode');

  function resultsRedirect(code) {
    document.body.classList.remove('loading');
    $('.success_msg').show();
    setTimeout(() => {
      window.location.href = `https://cc.fieracosmetics.com/aiwlp1`;
      console.log('Redirecting to:', code);
    }, 1000);
  }
  resultsRedirect(code);
}

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}
